// src/pages/.../TokenPopup.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import Popup from "../../../../assets/components/PopupGroup";
import { TwinColumn } from "../../../../assets/components/ButtonGroup";

export default function TokenPopup({ isOpen, onClose, origin = "home", returnTo, returnState }) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleGoBuy = () => {
    navigate("/myticket/non/tab", {
      state: { origin, returnTo, returnState },
    });
  };

  return (
    <Popup
      isOpen={isOpen}
      onClose={onClose}
      title="토큰이 필요해요"
      subtitle={`AI 이미지를 만들려면 토큰이 필요합니다. 
        현재 보유한 토큰이 없어 이용이 어려워요.
        토큰을 구매한 뒤 다시 이용해 주세요.`}
      renderButtons={
        <TwinColumn
          bottomText="닫기"
          bottomType="empty"
          topText="토큰 구매하기"
          onTop={handleGoBuy}
          onBottom={onClose}
        />
      }
    />
  );
}
